
import Js from "../../../assets/filled/Js.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function JsIcon({ className, dataTestid = "JsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Js data-testid={dataTestid} className={classes} {...rest} />
  );
}
